/* eslint-disable indent */
import React, {
    useEffect,
    useState,
    useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, useController } from 'react-hook-form';
import { BiChevronRight, BiChevronUp } from 'react-icons/bi';
import { FaFileExport } from 'react-icons/fa';
import { BsCheck } from 'react-icons/bs';
import { dateStringDot, hasAccess, loadOptionsCase } from '../../../utils';
import PositionalModal from '../../../lib/PositionalModal';
import fileImg from '../../../assets/images/icons/file.svg';
import dots from '../../../assets/images/icons/green-dots.svg';
import mailIcon from '../../../assets/images/icons/mail.svg';
import deleteIcon from '../../../assets/images/icons/delete.svg';
import moveFolderIcon from '../../../assets/images/icons/folder-move-to.svg';
import Loader from '../../Loader';

import styles from './file-item.module.scss';

const FileItem = ({
    file,
    selected,
    handleSelect,
    actions = {},
    initOptsMove = [],
}) => {
const { user } = useSelector((store) => store).authReducer;
const modalRef = useRef();
const modalParent = useRef();
const dispatch = useDispatch();
const [fileMoveSuccess, setFileMoveSuccess] = useState(false);
const [isMoveListOpened, setIsMoveListOpened] = useState(false);
const [optsMove, setOptsMove] = useState(null);

const {
    control,
    watch,
} = useForm();

const {
    field,
    fieldState: { value: valueSearch },
} = useController({
    name: 'search',
    control,
});

const watchSearch = watch('search');

// SET POSITION MODAL WHEN LIST CASE OPEN CHANGE
useEffect(() => {
    if (!actions.move) return;
    modalRef.current.setPositionModal();
}, [isMoveListOpened]);

// INIT OPTIONS MOVE
useEffect(() => {
    setOptsMove(initOptsMove);
}, [initOptsMove]);

// UPDATE OPTIONS MOVE
useEffect(() => {
    if (!optsMove) return;
    const getOpstsMoveToCases = async () => {
    const cases = await loadOptionsCase(watchSearch);
    setOptsMove(cases);
    };
    getOpstsMoveToCases();
}, [watchSearch]);

function openModal(e) {
    e.preventDefault();
    e.stopPropagation();
    modalRef.current.open();
}

function sendFile(e) {
    e.preventDefault();
    e.stopPropagation();
    modalRef.current.close();
    actions.send({ _id: file._id, name: file.name, type: 'file' });
}

function deleteFile(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!actions.delete || typeof actions.delete !== 'function') return;
    actions.delete(file);
}

async function dowloadFile(e) {
    e.preventDefault();
    e.stopPropagation();
    const config = {
    headers: {
        Authorization: `${localStorage.getItem('token')}`,
        agency: `${localStorage.getItem('agency')}`,
    },
    };
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/file/${file._id}`, config);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${file.name}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
    } catch (err) {
        console.log(err);
    }
}

function toggleListCase(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!optsMove) return;
    setFileMoveSuccess(null);
    setIsMoveListOpened((state) => !state);
}

async function moveFile(e, caseId) {
    e.preventDefault();
    e.stopPropagation();
    const response = await actions.move(dispatch, {
        _id: file._id,
        case: caseId,
    });
    setFileMoveSuccess(response.status === 200 ? caseId : null);
    setTimeout(() => {
        setFileMoveSuccess(null);
    }, 2000);
}

function getClassNameStatus(s) {
    let className = 'pending';
    switch (s) {
    case 'Litige':
        className = 'dispute';
        break;
    case 'En attente':
        className = 'pending';
        break;
    case 'En cours':
        className = 'in-progress';
        break;
    case 'Archivés':
        className = 'archived';
        break;
    default:
        className = 'pending';
        break;
    }
    return className;
}

return (
    <li>
    <PositionalModal
        ref={modalRef}
        parent={modalParent}
        alignmentX={'right'}
        alignmentY={'middle'}
        handleClose={() => setIsMoveListOpened(false)}
    >
        <div className={styles.containerActions} data-close-modal='false' onClick={(e) => e.stopPropagation()}>
        {(hasAccess(user.role) && actions.move) && (
            <div className={isMoveListOpened ? `${styles.moveFolderTo} ${styles.opened}` : styles.moveFolderTo}>
            <div
                className={styles.titleAction}
                onClick={(e) => toggleListCase(e)}
            >
                <img src={moveFolderIcon} alt={'déplacer vers un dossier d\'affaire'} />
                <p>Déplacer vers un dossier d'affaire</p>
                {optsMove
                ? <>
                    {isMoveListOpened
                    ? <BiChevronUp size={'23px'} />
                    : <BiChevronRight size={'23px'} />
                    }
                </>
                : <>
                    <div className={styles.loader}><Loader size={18} /></div>
                </>
                }
            </div>
            {isMoveListOpened && (
                <div>
                <div className={styles.fieldSearch}>
                    <input
                    {...field}
                    value={valueSearch}
                    name={'search'}
                    type='search'
                    placeholder='Rechercher une affaire...'
                    />
                </div>
                {fileMoveSuccess && <p className={styles['success-move']}>Votre fichier à été déplacé dans :</p>}
                <ul style={fileMoveSuccess ? { margin: 0 } : {}}>
                    {(optsMove || []).filter((d) => (
                    !fileMoveSuccess || (fileMoveSuccess && fileMoveSuccess === d.value)
                    )).map((c) => <li
                    key={`case-${c.value}`}
                    onClick={(e) => moveFile(e, c.value)}
                    >
                    <div className={`${styles.status} ${styles[getClassNameStatus(c.status)]}`} />
                    <p>
                        {c.label}
                    </p>
                    </li>)}
                </ul>
                </div>
            )}
            </div>
        )}
        {actions.print && (<div onClick={(e) => dowloadFile(e)}>
            <FaFileExport size='20px' />
            <p>Télécharger</p>
        </div>
        )}
        {actions.send && (<div onClick={(e) => sendFile(e)}><img src={mailIcon} alt='Envoyer par mail' /><p>Envoyer par mail</p></div>)}
        {(hasAccess(user.role) && actions.delete) && (
            <div onClick={(e) => deleteFile(e)}>
            <img src={deleteIcon} alt='Supprimer' />
            <p>Supprimer</p>
            </div>
        )}
        </div>
    </PositionalModal>
    <div className={styles.content}>
        <div>
        <img src={fileImg} alt={`dossier ${file.name}`} />
        <p>{file.name}</p>
        </div>
        <div className={styles.date}>
        {file.createdAt && dateStringDot(new Date(file.createdAt))}
        </div>
        <div className={styles.toggle}>
        <span onClick={openModal} ref={modalParent}>
            <img src={dots} alt={`action sur le dossier: ${file.name}`} />
        </span>
        </div>
    </div>
    <Checkbox checked={selected} handleClick={() => handleSelect(file._id, 'file')}/>
    </li>
);
};

const Checkbox = (({ checked, handleClick }) => {
useEffect(() => {}, []);
return (
    <div className={styles.checkbox} onClick={() => handleClick()}>
    {checked && <BsCheck />}
    </div>
);
});

export default FileItem;
